import React from "react";
import GenericDropdown from "../../components/GenericDropDown";

interface CouponFilterDropdownsProps {
  selectedVendorName: string;
  handleVendorChange: (value: string) => void;
  vendorList: any[];
  showVendorDropdown?: boolean;

  selectedCouponTypeName: string;
  handleCouponTypeChange: (value: string) => void;
  couponTypesData: any[];

  selectedStatusName: string;
  handleStatusChange: (value: string) => void;
}

const statusOptions = [
  { value: "18", label: "Active" },
  { value: "19", label: "Inactive" },
];

const FilterDropdowns: React.FC<CouponFilterDropdownsProps> = ({
  selectedVendorName,
  handleVendorChange,
  vendorList,
  showVendorDropdown = true,
  selectedCouponTypeName,
  handleCouponTypeChange,
  couponTypesData,
  selectedStatusName,
  handleStatusChange,
}) => {
  return (
    <div className="w-full flex flex-col gap-2 md:flex-row">
      {showVendorDropdown && (
        <div className="w-full">
          <GenericDropdown
            labelValue={selectedVendorName}
            onChange={handleVendorChange}
            options={vendorList.map((vendor: any) => ({
              value: vendor.id.toString(),
              label: vendor.company,
            }))}
            className="text-black bg-white h-9 w-full justify-center items-center text-nowrap"
            placeholder="Select a vendor"
            error={false}
          />
        </div>
      )}

      <div className="w-full">
        <GenericDropdown
          labelValue={selectedCouponTypeName}
          onChange={handleCouponTypeChange}
          options={couponTypesData.map((type: any) => ({
            value: type.id.toString(),
            label: type.name.toLowerCase(),
          }))}
          className="text-black bg-white h-9 w-full justify-center items-center text-nowrap"
          placeholder="Select coupon type"
          error={false}
        />
      </div>

      <div className="w-full">
        <GenericDropdown
          labelValue={selectedStatusName}
          onChange={handleStatusChange}
          options={statusOptions}
          className="text-black bg-white h-9 w-full justify-center items-center text-nowrap"
          placeholder="Select a status"
          error={false}
        />
      </div>
    </div>
  );
};

export default FilterDropdowns;
